// School-year label for a shoot date, e.g. "'26–'27".
// July onward starts the upcoming year; June and earlier closes out the current one.
const SEASON_START_MONTH = 7;

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

const twoDigit = (year: number): string => String(year % 100).padStart(2, '0');

const parseMonthAndYear = (
  dateString: string,
): { month: number; year: number } | null => {
  const iso = ISO_DATE.exec(dateString);
  if (iso) {
    // Parsed by hand: `new Date('2026-10-01')` is UTC midnight, which is the
    // previous month once a negative-offset browser reads it back.
    return { month: Number(iso[2]), year: Number(iso[1]) };
  }

  const parsed = new Date(dateString);
  if (Number.isNaN(parsed.getTime())) return null;

  return { month: parsed.getMonth() + 1, year: parsed.getFullYear() };
};

const seasonLabel = (dateString?: string | null): string | null => {
  if (!dateString) return null;

  const parsed = parseMonthAndYear(dateString);
  if (!parsed) return null;

  const startYear =
    parsed.month >= SEASON_START_MONTH ? parsed.year : parsed.year - 1;

  return `'${twoDigit(startYear)}–'${twoDigit(startYear + 1)}`;
};

export default seasonLabel;
